module.exports = __webpack_public_path__ + "img/UNSTI Winner Logo.6e765540.png";